import React from "react";
import {
  Box,
  List,
  ListItem,
  Typography,
  Dialog,
  DialogContent,
} from "@mui/material";
import { Link } from "react-router-dom";
import AvatarIcon from "../../../components/AvatarIcon";
import IconsAccounts from "../../../components/IconsAccounts";
import { ReactComponent as EmptyAcc } from "../../../images/No accounts.svg";
import { IOSSwitch } from "../styles";

const AccountSelectionDialog = ({
  open,
  onClose,
  accounts,
  tempSelAccs,
  showAccountsInfo,
  onToggleAccount,
  onChangeSelectedAccounts,
  tr,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "10px",
          backgroundColor: "var(--background-menu)",
        },
      }}>
      <Box
        sx={{
          backgroundColor: "var(--background-image)",
          borderRadius: "10px",
          width: "500px",
        }}>
        <Box
          sx={{
            borderBottom: "1px solid #4f5154",
            padding: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "var(--text-color)",
            }}>
            {tr("postPage.postTo")}
          </Typography>
        </Box>
        <DialogContent>
          <Box>
            {showAccountsInfo && accounts.length > 0 ? (
              <List component="div" className="flex column">
                {accounts.map((info, i) => {
                  const { id, social_type, avatar, username, state } = info;
                  const checked = tempSelAccs?.includes(id);
                  // Publishing to an account whose token is dead always fails, so it must
                  // not be selectable in silence — say why, and send the user to fix it
                  // (OP#2449).
                  const needsReconnect = state === "needs_reconnect";

                  return (
                    <ListItem
                      key={i}
                      onClick={() => !needsReconnect && onToggleAccount(id)}
                      sx={{ opacity: needsReconnect ? 0.55 : 1 }}>
                      <Box className="flex between items-center w-full">
                        <Box className="relative">
                          <Box sx={{ zIndex: 2, position: "relative" }}>
                            <AvatarIcon
                              avatar={avatar}
                              width="40px"
                              height="40px"
                            />
                          </Box>
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-13px",
                              right: "-15px",
                              zIndex: 1,
                            }}>
                            <IconsAccounts
                              socialType={social_type}
                              width={40}
                              height={40}
                              style={{ borderRadius: "50%" }}
                            />
                          </Box>
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-5px",
                              left: "70px",
                              whiteSpace: "nowrap",
                            }}>
                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "var(--text-color)",
                              }}>
                              {username}
                            </Typography>
                            {needsReconnect && (
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#ed6c02",
                                }}>
                                {tr("accountsPage.needsReconnect")}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        <Box>
                          {needsReconnect ? (
                            <Link
                              to="/app/accounts"
                              className="btnDark"
                              style={{ whiteSpace: "nowrap" }}>
                              {tr("accountsPage.reconnect")}
                            </Link>
                          ) : (
                            <IOSSwitch
                              onChange={() =>
                                onChangeSelectedAccounts([...tempSelAccs])
                              }
                              checked={checked}
                            />
                          )}
                        </Box>
                      </Box>
                    </ListItem>
                  );
                })}
              </List>
            ) : (
              <Box className="flex column items-center justify-center w-full h-full">
                <EmptyAcc width="250px" height="250px" />
                <Typography
                  variant="body1"
                  className="font w300"
                  sx={{ color: "var(--text-color)" }}>
                  {tr("dashboardPage.empty")}
                </Typography>
                <Typography
                  variant="body2"
                  className="font w300"
                  sx={{ color: "var(--text-login)" }}>
                  {tr("accountsPage.noAccounts")}
                </Typography>
                <Link
                  to="/app/accounts"
                  className="btnDark mt-4"
                  sx={{ borderRadius: "23px" }}>
                  {tr("accountsPage.add")}
                </Link>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default AccountSelectionDialog;
